import React, { useContext, useState } from "react";
import ArrowDownSVG from "../../../../svgs/ArrowDownSVG";
import { MainContext } from "../../../../context/Context";

interface Section {
  title: string;
  topics: string[];
}

const LeftSide = () => {
  const { Sections } = useContext(MainContext);
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeTitleIndex, setActiveTitleIndex] = useState(null);

  const handleMenu = (e: React.MouseEvent<HTMLElement>, index: number) => {
    setActiveTitleIndex(index);
    if (e.currentTarget.nextElementSibling.className.includes("hidden")) {
      e.currentTarget.classList.add("text-text3");
      e.currentTarget.nextElementSibling.classList.replace("hidden", "flex");
    } else {
      e.currentTarget.classList.remove("text-text3");
      e.currentTarget.nextElementSibling.classList.replace("flex", "hidden");
    }
  };
  const handleActiveTitle = (e: any, index: number) => {
    setActiveIndex(index);
    e.preventDefault();

    const targetId = e.currentTarget.getAttribute("href").substring(1);
    const targetElement = document.getElementById(targetId);

    const headerHeight = 64;

    const targetPosition =
      targetElement.getBoundingClientRect().top +
      window.scrollY -
      headerHeight -
      30;

    window.scrollTo({
      top: targetPosition,
      behavior: "smooth", // انیمیشن نرم
    });
  };
  return (
    <div className="w-[20%] relative pb-10">
      <div className="w-full flex flex-col sticky top-24 left-0">
        {Sections.map((item: Section, index: number) => (
          <div className="flex flex-col px-4 pb-4" key={index}>
            <div
              className="flex items-center justify-between text-[#999] cursor-pointer [&>svg>path]:stroke-white"
              onClick={(e) => handleMenu(e, index)}
            >
              <div
                className={`${activeTitleIndex === index ? "!text-white" : ""}`}
              >
                {item.title}
              </div>
              <ArrowDownSVG />
            </div>
            <div
              className={`${
                activeTitleIndex === index ? "flex" : "hidden"
              } flex-col text-text5 pl-5`}
            >
              {item.topics.map((topic: string, i: number) => (
                <a
                  className={`flex items-center gap-3 mt-3 ${
                    activeIndex === i ? "text-white" : ""
                  }`}
                  key={i}
                  href={`#${topic}`}
                  onClick={(e) => handleActiveTitle(e, i)}
                >
                  <span className="scale-[200%] relative bottom-[10px]">.</span>
                  <span>{topic}</span>
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LeftSide;
